/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-16 11:27:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/PrimaryActionButtonStyle/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFloatingActionButtonStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFloatingActionButtonStyle,
  onFloatingActionButtonStyleReset,
} from '../slice';

const idSet = {
  backgroundColour: suffix + 'floating-backgroundColour',
  textColour: suffix + 'floating-textColour',
  background1Colour: suffix + 'floating-backgroundColour1',
  textColour1: suffix + 'floating-textColour1',
};
const FloatingActionButtonStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const {
    customerServiceBackgroundColor,
    textColor,
    backToTopButtonBackgroundColor,
    backToTopIconColor,
  } = data || {};

  const _d = useDispatch();

  const handleOnBkgChange = (customerServiceBackgroundColor) => {
    _d(onFloatingActionButtonStyle({ customerServiceBackgroundColor }));
  };

  const handleOnTextChange = (textColor) => {
    _d(onFloatingActionButtonStyle({ textColor }));
  };

  const handleOnBkg1Change = (backToTopButtonBackgroundColor) => {
    _d(onFloatingActionButtonStyle({ backToTopButtonBackgroundColor }));
  };

  const handleOnText1Change = (backToTopIconColor) => {
    _d(onFloatingActionButtonStyle({ backToTopIconColor }));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          id={idSet.backgroundColour}
          title={getI18n(
            'salesChannelContent.index.customerServiceBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.backgroundColour}
            onChange={handleOnBkgChange}
            multi
            color={customerServiceBackgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.textColour}
          title={getI18n(
            'salesChannelContent.index.customerServiceText&IconColour',
          )}>
          <ColorPicker
            onChange={handleOnTextChange}
            multi
            id={idSet.textColour}
            color={textColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.background1Colour}
          title={getI18n(
            'salesChannelContent.index.backToTopButtonBackgroundColour',
          )}>
          <ColorPicker
            onChange={handleOnBkg1Change}
            multi
            id={idSet.background1Colour}
            color={backToTopButtonBackgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.textColour1}
          title={getI18n('salesChannelContent.index.backToTopIconColour')}>
          <ColorPicker
            onChange={handleOnText1Change}
            multi
            id={idSet.textColour1}
            color={backToTopIconColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(FloatingActionButtonStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.floatingActionButtonStyle,
  getContent: getFloatingActionButtonStyle,
  title: getI18nFromGeneral('general.hOCTitle.floatingActionButtonStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onFloatingActionButtonStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
